module.exports = __webpack_public_path__ + "static/img/企业logo1.26f8aff3.jpeg";